import { ordersApi } from '../services/ordersApi';

export const operatingStatusQueryKey = ['orders', 'operating-status'] as const;

export function operatingStatusQueryOptions() {
  return {
    queryKey: operatingStatusQueryKey,
    queryFn: () => ordersApi.getOperatingStatus(),
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    refetchOnMount: 'always' as const,
    refetchOnWindowFocus: true,
  };
}
